import { Component, Injector, OnInit, Input, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { LinkedUserDto, MyProfileOutput, ProfileServiceProxy, UserLinkServiceProxy } from '@shared/service-proxies/service-proxies';
import { LinkedAccountService } from '@app/shared/layout/linked-account.service';
import { AbpMultiTenancyService, AbpSessionService } from 'abp-ng2-module';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AppConsts } from '@shared/AppConsts';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { NavigationEnd, Router } from '@angular/router';
import { MyProfileComponent } from './my-profile/my-profile.component';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('topBarComponentData', { static: true }) topBarComponentData: MyProfileComponent;
    @Input() iconOnly = false;
    @Input() isDropup = false;
    @Input() togglerCssClass = 'btn btn-icon w-auto btn-clean d-flex align-items-center btn-md px-2';
    @Input() textCssClass = 'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-2 cursor-pointer';
    @Input() symbolCssClass = 'symbol symbol-35 symbol-light-success';
    @Input() symbolTextCssClass = 'symbol-label font-size-h5 font-weight-bold';
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1 mt-0';

    usernameFirstLetter = '';

    profilePicture = '';
    imgPath: string;
    imgPath1: string;
    userRole: any;

    shownLoginName = '';
    tenancyName = '';
    userName = '';
    profileName = '';
    demoShow: boolean;
    recentlyLinkedUsers: LinkedUserDto[];
    isImpersonatedLogin = false;
    isMultiTenancyEnabled = false;
    flag = false;
    mQuickUserOffcanvas: any;
    myProfileData: MyProfileOutput = new MyProfileOutput();
    mySubscription: any;
    uparrow = false;
    myProfileDataCheck: string;
    public constructor(
        private router: Router,
        injector: Injector,
        private _linkedAccountService: LinkedAccountService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _impersonationService: ImpersonationService,
        private _abpSessionService: AbpSessionService,
        _dateTimeService: DateTimeService,
        private _profileService: ProfileServiceProxy
    ) {
        super(injector, _dateTimeService);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.mySubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.router.navigated = false;
            }
        });
    }



    ngOnInit(): void {
        //
        this.demoShow = false;
        this.imgPath = '';
        this.userRole = '';
        this.imgPath1 = '';
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;
        this.isMultiTenancyEnabled = this._abpMultiTenancyService.isEnabled;
        this.setCurrentLoginInformations();
        //this.getProfilePicture();
        this.myProfileInfo();
        //this.getRecentlyLinkedUsers(); //no need to call this method we are not using APIs response data
        this.usernameFirstLetter = this.appSession.user.userName.substring(0, 1).toUpperCase();
     
    }

    ngAfterViewInit(): void {
    
        this.mQuickUserOffcanvas = new KTOffcanvas('kt_quick_user', {
            overlay: true,
            baseClass: 'offcanvas',
            placement: 'right',
            closeBy: 'kt_demo_panel_close',
            toggleBy: 'kt_quick_user_toggle'
        });

        //this.mQuickUserOffcanvas.events.push({
        //    name: 'beforeShow',
        //    handler: () => {
        //        abp.event.trigger('app.show.quickUserPanel');
        //    }
        //});
    
       // this.myProfileInfo();
      //  this.getMyProfile();
    }

    ngOnDestroy() {
        if (this.mySubscription) {
            this.mySubscription.unsubscribe();
        }
    }

    myProfileInfo() {
     
        let loggedUserData = localStorage.getItem('MyProfileData');
        this.myProfileData = JSON.parse(loggedUserData);
         var image =  localStorage.getItem('imagePath');
         if (this.myProfileData != undefined || this.myProfileData != null) {
             if (this.myProfileData.firstName !== null && this.myProfileData.lastName !== null) {
                 this.profileName = this.myProfileData.firstName + ' ' + this.myProfileData.lastName;
                }
                this.myProfileData.roleName = this.myProfileData.roleName?.map(x => this.l(x));
                
                if(image === null){
                   this.imgPath = this.myProfileData.imagePath; 
                }
                else
                {
                  this.imgPath =image;
                }
                
            // console.log('User-Img', this.imgPath);
            AppConsts.loggedInUserImage = this.imgPath;
        }
    }



    setCurrentLoginInformations(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
        this.tenancyName = this.appSession.tenancyName;
        this.userRole = this.appSession.user.userRole;
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (linkedUser.tenantId ? linkedUser.tenancyName : '.') + '\\' + linkedUser.username;
    }
    getMyProfile() {
        this.router.navigate(['/app/myProfile']);
    }

    // getProfilePicture(): void {
    //     this._profileServiceProxy.getProfilePicture().subscribe(result => {
    //         this.imgPath = '';
    //         if (result && result.profilePicture) {
    //             this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
    //         }
    //         this.imgPath = this.profilePicture;


    //     });
    // }

    myMethod() {
        
        this.flag = true;
      //  this.ngAfterViewInit();
      //  this.router.navigate(['/app/myProfile']);
        //this.getProfilePicture();
    }

    getRecentlyLinkedUsers(): void {
        this._userLinkServiceProxy.getRecentlyUsedLinkedUsers().subscribe(result => {
            this.recentlyLinkedUsers = result.items;
        });
    }



    logout(): void {
        sessionStorage.clear();
        abp.event.trigger('SignalRClearBeforeLogout');
        this._authService.logout();
    }

    onMySettingsModalSaved(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(linkedUser.id, linkedUser.tenantId);
    }

    downloadCollectedData(): void {
        this._profileServiceProxy.prepareCollectedData().subscribe(() => {
            this.message.success(this.l('GdprDataPrepareStartedNotification'));
        });
    }

    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    userFullname(name: string) {
        if(!name)return '-';
        let fullname = name.split(" ");
        name = fullname.length > 1 ?this.getTitleCase(fullname[0])+" "+this.getTitleCase(fullname[1]) : this.getTitleCase(fullname[0]);
         return name ;
     }
 
     // function which return titlecase string;
     getTitleCase(s : string){
        if(s[0] !==" " && s !== undefined)
        {
            let char = s ? s[0].toUpperCase() : '';
        return char + s.slice(1)?.toLowerCase();
        }         
            
        }
}
